import { Text } from '../text/text';
import { clsx } from 'clsx';
import { alertStyles, alertVariants, alertSlideVariants } from './alert.css';
import { Box } from '../box/box';
import { Columns } from '../columns/columns';
import { CSSProperties } from 'react';

export type AlertProps = {
  message?: string | React.ReactNode;
  severity: 'error' | 'notify';
  css?: CSSProperties;
  className?: string;
  slide?: keyof typeof alertSlideVariants;
};

export function Alert({ severity, message, css, className, slide }: AlertProps) {
  if (!message) return null;
  return (
    <Box
      className={clsx(
        alertStyles,
        alertVariants[severity],
        slide && alertSlideVariants[slide],
        className,
      )}
      data-component="Alert"
      css={{ ...css }}
    >
      <Columns style={{ padding: 16 }}>
        <Text>{message}</Text>
      </Columns>
    </Box>
  );
}
